import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from './authSlice';
import api from './config';

const initialState = {
  loading: false,
  errors: []
};

const normalizeErrors = (payload) =>
  Array.isArray(payload?.message)
    ? payload.message
    : [payload?.message].filter(Boolean);

export const createStaffAccount = createAsyncThunk(
  'staffAccount/create',
  async (
    {
      email, phone, password, firstname, lastname, proposedPosition, departmentKeys, contractType, startDate, endDate,
      age, idCardNumber, grossSalary, netSalary,
      canRespondToClaims, canViewReservations, canViewServiceCalls
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await api.post('/staff-account', {
        email,
        phone,
        password,
        firstname,
        lastname,
        proposedPosition,
        departmentKeys,
        contractType,
        startDate,
        endDate,
        age,
        idCardNumber,
        grossSalary,
        netSalary,
        canRespondToClaims,
        canViewReservations,
        canViewServiceCalls
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) dispatch(logout());
      if (!error.response) throw error;
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStaffPermissions = createAsyncThunk(
  'staffAccount/updatePermissions',
  async ({ staffId, canRespondToClaims, canViewReservations, canViewServiceCalls }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.patch(`/staff-account/${staffId}/permissions`, {
        canRespondToClaims,
        canViewReservations,
        canViewServiceCalls
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) dispatch(logout());
      if (!error.response) throw error;
      return rejectWithValue(error.response.data);
    }
  }
);

const staffAccountSlice = createSlice({
  name: 'staffAccount',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createStaffAccount.pending, (state) => { state.loading = true; })
      .addCase(createStaffAccount.fulfilled, (state) => { state.loading = false; })
      .addCase(createStaffAccount.rejected, (state, { payload }) => {
        state.errors = normalizeErrors(payload);
        state.loading = false;
      })
      .addCase(updateStaffPermissions.pending, (state) => { state.loading = true; })
      .addCase(updateStaffPermissions.fulfilled, (state) => { state.loading = false; })
      .addCase(updateStaffPermissions.rejected, (state, { payload }) => {
        state.errors = normalizeErrors(payload);
        state.loading = false;
      });
  }
});

export default staffAccountSlice.reducer;
